/**
 * Notification service for managing in-app notifications.
 */
import { directApi } from './api';

const notificationService = {
  /**
   * Get notifications for the current user.
   * @param {boolean} unreadOnly - If true, only return unread notifications
   * @param {number} limit - Maximum number of notifications to return
   * @returns {Promise<{notifications: Array, unread_count: number}>}
   */
  async getNotifications(unreadOnly = false, limit = 50) {
    const params = new URLSearchParams();
    if (unreadOnly) params.append('unread_only', 'true');
    if (limit) params.append('limit', limit.toString());
    
    const response = await directApi.get(`/notifications?${params.toString()}`);
    return response.data;
  },

  /**
   * Get unread notification count.
   * @returns {Promise<number>}
   */
  async getUnreadCount() {
    const response = await directApi.get('/notifications/unread-count');
    return response.data.unread_count;
  },

  /**
   * Mark a notification as read.
   * @param {number} notificationId - Notification ID
   * @returns {Promise<boolean>}
   */
  async markAsRead(notificationId) {
    const response = await directApi.post(`/notifications/${notificationId}/read`);
    return response.data.success;
  },

  /**
   * Mark all notifications as read.
   * @returns {Promise<{success: boolean, count: number}>}
   */
  async markAllAsRead() {
    const response = await directApi.post('/notifications/read-all');
    return response.data;
  },

  /**
   * Dismiss a notification.
   * @param {number} notificationId - Notification ID
   * @returns {Promise<boolean>}
   */
  async dismiss(notificationId) {
    const response = await directApi.post(`/notifications/${notificationId}/dismiss`);
    return response.data.success;
  }
};

export default notificationService;
